import React from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../../data/projects';
import { getProjectThumbnail } from '../../utils/projectImages';
import { useLanguage } from '../../context/LanguageContext';
import { getCopy } from '../../data/siteCopy';
import { getLocalizedProjectField } from '../../data/projects';
import './Home.css';

const Home = () => {
  const { language } = useLanguage();
  const copy = getCopy(language);

  return (
    <main className="home">
      {/* Hero Section */}
      <section className="hero">
        <span className="hero-label">{copy.home.label}</span>
        <h1 className="hero-title">{copy.home.title}</h1>
        <p className="hero-subtitle">{copy.home.subtitle}</p>
        <div className="hero-contact">
          <a href="mailto:augusta.silva.design@gmail.com" className="hero-email">
            augusta.silva.design@gmail.com
          </a>
          <a 
            href="https://instagram.com/gusmagarts" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hero-social"
            aria-label={copy.home.socialAria}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
            </svg>
          </a>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="projects-section">
        <div className="projects-grid">
          {projects.map((project) => (
            <Link
              to={`/project/${project.slug}`}
              key={project.slug}
              className="project-card"
            >
              <div className="project-card-image">
                {getProjectThumbnail(project) ? (
                  <img src={getProjectThumbnail(project)} alt={project.title} />
                ) : (
                  <div className="project-card-placeholder">
                    <span>{project.title.charAt(0)}</span>
                  </div>
                )}
              </div>
              <div className="project-card-content">
                <span className="project-card-category">
                  {getLocalizedProjectField(project, language, 'category')}
                </span>
                <h2 className="project-card-title">{project.title}</h2>
                {Array.isArray(project.technologies) && project.technologies.length > 0 && (
                  <div className="project-card-tags" aria-label={copy.projectPage.technologies}>
                    {project.technologies.map((technology) => (
                      <span key={technology} className="project-card-tag">
                        {technology}
                      </span>
                    ))}
                  </div>
                )}
                <p className="project-card-description">
                  {getLocalizedProjectField(project, language, 'shortDescription')}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Home;
